import { React, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';
import "./index.scss";

import ProfileAvatar from "../../../ui/ProfileAvatar";
import SkeletonLoader from "../../../ui/SkeletonLoader";


import UpdateUserStatusModal from "../UpdateUserStatusModal";

import { formatDate, getUserImageUrl, formatNumber, getloggedInUserType } from "../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { resetUserDetailsResponse } from "../../../../store/actions/usersAction";

const UsersTileView = ({usersList, loading}) => {

    const updateUserStatusSingleResponse = useSelector((state) => state.users?.updateUserStatusSingleResponse);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const [showUpdateUserStatusModal, setShowUpdateUserStatusModal] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState(null);

    const updatedUserStatus = (data) => {
        setShowUpdateUserStatusModal(true);
        setSelectedUserData(data)
    }

    const getSecondaryText = (data) => {
        if(getloggedInUserType() === "internal") {
            return `${data?.role} | ${data.user_type} ${data?.customer_detail?.name !== null ? `- ${data?.customer_detail?.name}` : ""}`;
        } else {
            return `${data?.role}`
        }
    }

    useEffect(()=>{
        if(updateUserStatusSingleResponse != null) {
            setShowUpdateUserStatusModal(false)
        }
    },[updateUserStatusSingleResponse])

    return (
        <>
            <Row>
                {
                    loading ?
                        <>
                            <Col xl={12}>
                                <div className="organization-container mt-4 px-4 py-3 rounded h-100">
                                    <SkeletonLoader type={"line"} count={4} currentPage={"users"} />
                                </div>
                            </Col>
                        </>
                    :
                    <>
                        {
                            usersList?.results.length > 0 &&
                            usersList?.results.map((data, index) =>{
                                return (
                                    <Col xl="6" lg="12" md="12" key={index} className="col-xxxl-4 my-2">
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            // whileInView={{ opacity: 1, y: 0 }}
                                            // viewport={{ once: true }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <div className="organization-container mt-4 px-4 py-3 rounded h-100">
                                                <div className="organization-profile">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="organization-details user-details">
                                                            <ProfileAvatar type="profile" 
                                                                secondaryText={data?.role !== null ? getSecondaryText(data) : "Role Not Assigned"} 
                                                                firstName={data.firstname} 
                                                                lastName={data.lastname} 
                                                                imageUrl={getUserImageUrl(data)} 
                                                                tags={true} 
                                                                tagContent={data.status} 
                                                                tagColor={data.status === "active" ? "green" : "disabled"}
                                                                emailVerifiedStatus={data?.email_status}
                                                            />
                                                        </div>
                                                        <div className="organization-actions">
                                                            {data.status !== "active" &&<button className="view-details-btn active-user" onClick={()=>{updatedUserStatus(data)}}>{t("users.activateuser")}</button>}
                                                            {data.status === "active" && <button className="view-details-btn disable-user" onClick={()=>{updatedUserStatus(data)}}>{t("users.disableUser")}</button>}
                                                            <button className="view-profile-btn" onClick={()=>{
                                                                dispatch(resetUserDetailsResponse())
                                                                navigate(`/users/details/${data.user_id}`)                                                    
                                                                }}>{t("users.viewBtn")}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="user-scan-details mt-2">
                                                    <div className="mt-4 mb-4 d-flex align-items-center justify-content-between">
                                                        <p className="date-details"><span>{t("users.joinedOn")}</span> {formatDate(data?.created_at)}</p>
                                                        <p className="date-details"><span>{t("users.lastLogin")}</span> {data?.last_login !== null ? formatDate(data?.last_login) : <span>&nbsp;&nbsp;-</span>} </p>
                                                    </div>
                                                    <Row>
                                                        <Col lg={4}>
                                                            <div className="scan-count p-3">
                                                                <p className="label">{t("users.totalScan")}</p>
                                                                <p className="value">{formatNumber(data?.stats?.scans?.total)}</p>
                                                            </div>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <div className="scan-count p-3">
                                                                <p className="label">{t("users.totalActiveScan")}</p>
                                                                <p className="value">{formatNumber(data?.stats?.scans?.active)}</p>
                                                            </div>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <div className="scan-count p-3">
                                                                <p className="label">{t("users.totalPassiveScan")}</p>
                                                                <p className="value">{formatNumber(data?.stats?.scans?.passive)}</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </motion.div>                                        
                                    </Col>
                                )
                            })
                        }
                    </>
                    
                }
                <UpdateUserStatusModal show={showUpdateUserStatusModal} selectedUserData={selectedUserData} onHide={() => setShowUpdateUserStatusModal(false)}/>
            </Row>
        </>
    )
}

export default UsersTileView;